import type { SVGProps } from "react";

import { cn } from "@/lib/utils";

export default function FilterIcon({ className, ...props }: SVGProps<SVGSVGElement>) {
	return (
		<svg
			viewBox="0 0 319.76 374.38"
			xmlns="http://www.w3.org/2000/svg"
			width="18"
			height="18"
			className={cn("filter-sheet-icon shrink-0", className)}
			style={{ width: "18px", height: "18px", flexShrink: 0 }}
			{...props}
		>
			<g>
				<g>
					{/* Teal circles - keep original color */}
					<path
						fill="#3fdfcf"
						d="M168.07,240.27c41.58,8,38.7,70.48,0,76-1.96,3.53-14.04,3.53-16,0-38.72-5.52-41.73-67.98,0-76,4.34-.83,11.66-.83,16,0ZM144.43,293.91c20.28,20.31,51.34-10.7,31.64-31.14-20.08-20.83-52.54,10.21-31.64,31.14Z"
					/>
					<g>
						{/* Rails: see globals — .filter-sheet-icon__line (foreground / brand primary in dark) */}
						<path
							className="filter-sheet-icon__line"
							d="M168.07,240.27c-1.56,1.74-4.22,2.19-8,1.37-3.78.82-6.44.36-8-1.37l.52-235.98c3.72-5.71,11.22-5.73,14.96,0l.52,235.98Z"
						/>
						<path
							className="filter-sheet-icon__line"
							d="M168.07,316.27l-.06,51.44c-1.39,8.85-14.5,8.83-15.88,0l-.06-51.44c3.23.46,12.77.46,16,0Z"
						/>
					</g>
				</g>
				<g>
					{/* Teal circles - keep original color */}
					<path
						fill="#3fdfcf"
						d="M289.07,119.27c41.17,7.82,40.67,68.1,0,75-1.57,4.12-14.5,4.23-16,0-40.39-7.81-39.9-66.97,0-75,1.76-4.22,14.21-4.17,16,0ZM275.81,135.51c-24.31,4.19-20.64,45.12,6.62,43.7,29.03-1.51,27.55-49.59-6.62-43.7Z"
					/>
					<g>
						<path
							className="filter-sheet-icon__line"
							d="M289.07,194.27l.02,172.52c-1,10.11-15.04,10.13-16.04,0l.02-172.52c6.84,1.32,9.2,1.15,16,0Z"
						/>
						<path
							className="filter-sheet-icon__line"
							d="M289.07,119.27c-6.26-1.19-9.72-1.26-16,0l.52-114.98c3.72-5.71,11.22-5.73,14.96,0l.52,114.98Z"
						/>
					</g>
				</g>
				<g>
					{/* Teal circles - keep original color */}
					<path
						fill="#3fdfcf"
						d="M47.07,58.27c38.53,5.5,40.89,68.5,0,76-3.07.56-13.92.56-17,0C12.79,131.1-.65,111.87.02,94.72c.61-15.52,14.3-34.07,30.04-36.46l1.31-2.15c2.74-.79,14.83-1.03,15.69,2.15ZM34.8,74.51c-26.81,4.51-22.32,46.63,6.66,43.64s23.44-48.71-6.66-43.64Z"
					/>
					<g>
						<path
							className="filter-sheet-icon__line"
							d="M47.07,134.27l.02,232.52c-1.41,12.11-17.9,8.57-17.06-2.98l.04-229.54,1.53-1.82h13.94s1.53,1.82,1.53,1.82Z"
						/>
						<path
							className="filter-sheet-icon__line"
							d="M47.07,58.27c-3.3-.47-13.74-.5-17,0,1.47-15.38-2.02-34.48.09-49.41,1.61-11.4,15.4-11.27,16.85-2.03l.06,51.44Z"
						/>
					</g>
				</g>
			</g>
		</svg>
	);
}
